angular.module('bmsApp.settings').controller('UserManagementIndexCtrl',
	function ($scope, ngTableParams, $state, $ngBootbox, UserManagementSvc, AuthEmployeeSvc, notify) {

		$scope.loading = true;
		$scope.processing = false;

		$scope.tableParams = new ngTableParams(angular.extend({
			page: 1, // show first page
			count: $scope.config.table.params.count, // count per page
			sorting: {
				username: 'asc' // initial sorting
			},
			filter: {
				Search: $scope.filterText,
				UserType:''
			},
		}), {
			total: 0, // length of data
			counts: $scope.config.table.settings.counts, // available page counts
			getData: function ($defer, params) {
				UserManagementSvc.index(params.$params)
					.then(function (response) {
						params.total(response.data.user_filtered_count);
						$scope.loading = false;
						$scope.updating = false;
						$defer.resolve(response.data.user_collection);
					});
			}
		});

		$scope.employeeTableParams = new ngTableParams(angular.extend({
			page: 1, // show first page
			count: $scope.config.table.params.count, // count per page
			sorting: {

			},
			filter: {
				Search: $scope.filterText,
			},
		}), {
			total: 0, // length of data
			counts: $scope.config.table.settings.counts, // available page counts
			getData: function ($defer, params) {
				AuthEmployeeSvc.index(params.$params)
					.then(function (response) {
						params.total(response.data.employee_count);
						$scope.loading = false;
						$scope.updating = false;
						$defer.resolve(response.data.employee_collection);
					});
			}
		});

		$scope.filterChanged = function () {
			$scope.updating = true;
			$scope.tableParams.$params.filter.Search = $scope.filterText;
		};

		$scope.rowClicked = function(user){
			$state.go('main.settings.userManagement.edit', {id: user.id});
		};

		$scope.employeeRowClicked = (employee) => {
			$state.go('main.employee.index.view.update', {employeeId: employee.id});
		};

		$scope.convertToUser = function(employee) {
			$state.go('main.settings.userManagement.employeeCreate', {employeeId: employee.id});
		};

		$scope.resetAppPin = function(user,$event) {
			$event.stopPropagation();
			$ngBootbox.confirm('Reset app pin?')
				.then(function () {
					$scope.loading = true;
					UserManagementSvc.resetAppPin(user).then(function (response) {
						$scope.employeeTableParams.reload();
					});
				});
		};

		$scope.resendActivationEmail = function(user, $event) {
			$event.stopPropagation();
			user.sending_mail = true;
			UserManagementSvc.resendActivationEmail({id: user.id})
				.then(function (response) {
					user.sending_mail = false;
					user.verified = 1;
					notify({
						message: 'Account activation email sent successfully'
					});
				});
		};

		$scope.employeeSelected = function($event) {
			$event.stopPropagation();
		};

		$scope.bulkConvertToUser = function() {
			var selectedEmployees = [];
			angular.forEach($scope.employeeTableParams.data, function(employee){
				if(employee.selected){
					selectedEmployees.push(employee);
				}
			});
			if(selectedEmployees.length == 0){
				notify({
					message: 'Please select one or more employees',
					'class': 'errors',
				});
				return;
			}
			$scope.processing = true;
			UserManagementSvc.createFromEmployees({'employees' : selectedEmployees})
				.then(function (response) {
					notify({
						message: 'Selected employees converted to user account successfully'
					});
					$scope.processing = false;
					$scope.employeeTableParams.reload();
				}, function (error) {
					$scope.processing = false;
					$scope.errors = error;
				});
		};
	});
